// Linkable IDX Broker search. On the Core plan the embedded map widget
// cannot be filtered externally, so real multi-criteria search is done by
// sending the user to the brand-wrapped IDX results page (a styled,
// filterable map + list). All IDs below are verified live against the GSMLX
// feed (idxID d025).

export const IDX_MLS_ID = "d025";
export const IDX_RESULTS_BASE =
  "https://johnsellsnj.idxbroker.com/idx/results/listings";

export interface LocationOption {
  label: string;
  ccz: "city" | "county";
  id: string;
}

// John's core NJ markets — verified IDX city/county IDs.
export const locationOptions: LocationOption[] = [
  { label: "Princeton", ccz: "city", id: "37892" },
  { label: "West Windsor", ccz: "city", id: "51151" },
  { label: "Hamilton", ccz: "city", id: "56964" },
  { label: "Robbinsville", ccz: "city", id: "39671" },
  { label: "Lawrenceville", ccz: "city", id: "61535" },
  { label: "Trenton", ccz: "city", id: "53535" },
  { label: "Monmouth County", ccz: "county", id: "278" },
  { label: "Ocean County", ccz: "county", id: "1636" },
  { label: "Middlesex County", ccz: "county", id: "1476" },
];

export const propertyTypeOptions = [
  { label: "Any Type", value: "" },
  { label: "Single Family", value: "1" },
  { label: "Multi-Family", value: "3" },
  { label: "Land", value: "4" },
  { label: "Commercial", value: "5" },
];

// Real price points only; the "No Min"/"No Max" option is added in the UI.
export const priceOptions = [
  { label: "$200k", value: "200000" },
  { label: "$300k", value: "300000" },
  { label: "$400k", value: "400000" },
  { label: "$500k", value: "500000" },
  { label: "$600k", value: "600000" },
  { label: "$750k", value: "750000" },
  { label: "$1M", value: "1000000" },
  { label: "$1.5M", value: "1500000" },
  { label: "$2M", value: "2000000" },
  { label: "$3M", value: "3000000" },
  { label: "$5M", value: "5000000" },
];

export const bedBathOptions = [
  { label: "Any", value: "" },
  { label: "1+", value: "1" },
  { label: "2+", value: "2" },
  { label: "3+", value: "3" },
  { label: "4+", value: "4" },
  { label: "5+", value: "5" },
];

// IDX Broker `srt` parameter values (verified against IDX Broker docs).
export const sortOptions = [
  { label: "Newest", value: "newest" },
  { label: "Price (Low to High)", value: "pra" },
  { label: "Price (High to Low)", value: "prd" },
  { label: "Beds", value: "bdd" },
  { label: "Baths", value: "tbd" },
  { label: "Square Feet", value: "sqftd" },
];

export interface SearchCriteria {
  locationId?: string;
  type?: string;
  minPrice?: string;
  maxPrice?: string;
  beds?: string;
  baths?: string;
  sort?: string;
}

export const buildIdxSearchUrl = (c: SearchCriteria): string => {
  const p = new URLSearchParams();
  p.set("idxID", IDX_MLS_ID);
  const loc = locationOptions.find((o) => o.id === c.locationId);
  if (loc) {
    p.set("ccz", loc.ccz);
    p.append(loc.ccz === "county" ? "county[]" : "city[]", loc.id);
  }
  if (c.type) p.set("pt", c.type);
  if (c.minPrice) p.set("lp", c.minPrice);
  if (c.maxPrice) p.set("hp", c.maxPrice);
  if (c.beds) p.set("bd", c.beds);
  if (c.baths) p.set("tb", c.baths);
  if (c.sort) p.set("srt", c.sort);
  return `${IDX_RESULTS_BASE}?${p.toString()}`;
};

